import React from 'react'
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';

interface GoldMemberProp {
  cart_id?: number | any
  total?: number | any
  gold?:number | any
}

export const GoldMember = ({ cart_id, total, gold }: GoldMemberProp) => {
  const { applyGold, handleClick, isClickData } = useShoppingCart();

  const savePrice = Math.round(10 / 100 * total);
  const data = {
    "cart_id": cart_id,
  }
  return (
    <div className='goldMemberWrapper'>
      <div className='applyGoldMember'>
        <p className='goldDiscount'>Save Rs. {savePrice} more with <span className='goldTag'>Exclusive</span></p>
      </div>

      <p className="goldBenefits">Free Delivery &nbsp; &nbsp;| &nbsp; &nbsp;Extra 10% OFF &nbsp; &nbsp;| &nbsp; &nbsp;365 Days</p>

      <div className='visionPlusWrapper'>
        <button className='goldCTA ripple' onClick={() => {applyGold(data)}}>Add Xclusive</button>

        <a href="https://aqualens.in/pages/exclusive-membership">
          <button className='exclusiveDetailsCTA ripple'>View Details</button>
        </a>
      </div>

    </div>
  )
}
